module.exports = __webpack_public_path__ + "static/media/usina-rdg.e6630824.jpeg";